module.exports = __webpack_public_path__ + "assets/youtube.b389a8c9.svg";